<div class="container">
  <div class="col-md-12">
    <div class="page-header">
      <h2><i class="fa fa-flask"></i> Agilx Feature Flags</h2>
      <p class="lead text-muted">
        Toggle experimental features on or off. Changes are saved automatically.
      </p>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="status-bar">
          <span class="badge badge-info">
            {{ getEnabledCount() }} / {{ getTotalCount() }} features enabled
          </span>
          <div class="btn-group pull-right">
            <button class="btn btn-success btn-sm" (click)="enableAll()">
              <i class="fa fa-check-circle"></i> Enable All
            </button>
            <button class="btn btn-danger btn-sm" (click)="disableAll()">
              <i class="fa fa-times-circle"></i> Disable All
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Available Features</h3>
          </div>
          <div class="panel-body">
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th style="width: 60px">Status</th>
                  <th>Feature</th>
                  <th>Description</th>
                  <th style="width: 100px">Toggle</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let feature of featureFlagInfo">
                  <td>
                    <span
                      class="badge"
                      [ngClass]="{
                        'badge-success': featureFlags && featureFlags[feature.key],
                        'badge-secondary': !featureFlags || !featureFlags[feature.key]
                      }"
                    >
                      {{ featureFlags && featureFlags[feature.key] ? "ON" : "OFF" }}
                    </span>
                  </td>
                  <td>
                    <strong>{{ feature.label }}</strong>
                  </td>
                  <td class="text-muted">{{ feature.description }}</td>
                  <td>
                    <p-inputSwitch
                      [ngModel]="featureFlags && featureFlags[feature.key]"
                      (onChange)="onToggle(feature.key)"
                    ></p-inputSwitch>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-info">
          <i class="fa fa-info-circle"></i>
          <strong>Note:</strong> Feature flag settings are stored locally in your browser and will
          persist across sessions. Changes take effect immediately without page reload.
        </div>
      </div>
    </div>
  </div>
</div>
